import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CreateButtonWithModal from '../components/common/CreateButtonWithModal';
import BlackWhiteSwitch from '../components/common/BlackWhiteSwitch';
import DeleteButton from '../components/common/DeleteButton';
import EditModal from '../components/common/EditModal';

interface Column {
  id: keyof Data | 'action';
  label: string;
  minWidth?: number;
  align?: 'right' | 'center' | 'left';
}

const columns: readonly Column[] = [
  { id: 'name', label: 'Name', minWidth: 150 },
  { id: 'code', label: 'Code', minWidth: 100 },
  { id: 'status', label: 'Status', minWidth: 100 },
  { id: 'createdBy', label: 'Created By', minWidth: 120 },
  { id: 'action', label: 'Action', minWidth: 120, align: 'center' },
];

interface Data {
  name: string;
  code: string;
  status: string;
  createdBy: string;
}

function createData(
  name: string,
  code: string,
  status: string,
  createdBy: string
): Data {
  return { name, code, status, createdBy };
}

const initialRows: Data[] = [
  createData('India', 'IN', 'Active', 'Admin'),
  createData('USA', 'US', 'Inactive', 'John'),
  createData('United Kingdom', 'UK', 'Active', 'Emma'),
  createData('Japan', 'JP', 'Inactive', 'Satoshi'),
];

const Continents = () => {
  const [rows, setRows] = useState<Data[]>(initialRows);
    const [editOpen, setEditOpen] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const handleChangePage = (_: unknown, newPage: number) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };
  
    const handleEditSave = (updatedData: Data) => {
      if (selectedRowIndex === null) return;
      const updatedRows = [...rows];
      updatedRows[selectedRowIndex] = updatedData;
      setRows(updatedRows);
      setEditOpen(false);
    };
  
    const renderStatusButton = (status: string) => (
      <Button
        variant="contained"
        size="small"
        sx={{
          backgroundColor: status === 'Active' ? '#1cad2d' : '#e31a24',
          color: 'white',
          fontWeight: 'bold',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: status === 'Active' ? '#2e7d32' : '#c62828',
          },
        }}
      >
        {status}
      </Button>
    );
  
    const handleDeleteRow = (code: string) => {
      const updatedRows = rows.filter((row) => row.code !== code);
      setRows(updatedRows);
      console.log(`Deleted row with code: ${code}`);
    };
    
    const renderActions = (row: Data, index: number) => (
      <>
        <IconButton
          color="primary"
          size="small"
          onClick={() => {
            setSelectedRowIndex(index);
            setEditOpen(true);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton color="error" size="small">
          <DeleteButton
          onDelete={() => handleDeleteRow(row.code)}
          confirmMessage="Do you really want to delete this item?"
        />
          </IconButton>
      </>
    );




  return (
    <>
      <Box className="headingBtnWrap">
        <Typography variant="h1">Continents</Typography>
        <CreateButtonWithModal modalTitle="Continents">
          <Box className="modalFormWrap">
        <Box component="form" className="modalForm">
            <div className="form-control inputFieldWrap">
                <label>Name</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>Code</label>
                <input type="text" className='inputField' />
            </div>
        </Box>
        <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" className='formBtn'>Save</Button>
            </Box>
        </Box>
            <BlackWhiteSwitch />
      </CreateButtonWithModal>
      </Box>
      {/* <Box className="searchFilterWrap">
        <h2>Search Filter</h2>
        <Box component="form" className="modalForm">
            <div className="form-control inputFieldWrap">
                <label>Name</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>Code</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>Status</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>CreatedBy</label>
                <input type="text" className='inputField' />
            </div>
            <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" className='formBtn'>Search</Button>
            </Box>
        </Box>
      </Box> */}
      {/* <Box
      display="flex"
      alignItems="center"
      gap={2}
      p={2}
      sx={{ width: '100%', maxWidth: 600, mx: 'auto' }}
      className="searchFilterDropdownWrap"
    >
      <TextField
        fullWidth
        variant="outlined"
        className="searchFilterInput"
        placeholder='Search Filter'
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') handleSearch();
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton onClick={handleSearch} edge="start">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <Select
          value={age}
          onChange={handleChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          className='searchFilterDropdown'
        >
          <MenuItem value="">
            <em>Select Filter</em>
          </MenuItem>
          <MenuItem value={10}>Name</MenuItem>
          <MenuItem value={20}>Code</MenuItem>
          <MenuItem value={30}>Status</MenuItem>
        </Select>
      </FormControl>
      <Button variant="contained" className='searchBtn'>Search</Button>
    </Box> */}
      <Paper sx={{ width: '100%', overflowX: 'auto' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="continent table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                  <TableRow hover key={rowIndex}>
                                      {columns.map((column) => {
                                        const value = row[column.id as keyof Data];
                                        if (column.id === 'status') {
                                          return <TableCell key={column.id}>{renderStatusButton(value)}</TableCell>;
                                        }
                                        if (column.id === 'action') {
                                          return (
                                            <TableCell key={column.id} align="center">
                                              {renderActions(row, rowIndex)}
                                            </TableCell>
                                          );
                                        }
                                        
                                        
                                        return <TableCell key={column.id}>{value}</TableCell>;
                                      })}
                                    </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
      </Paper>
      {/* Edit Modal */}
      {selectedRowIndex !== null && (
          <EditModal
            open={editOpen}
            onClose={() => setEditOpen(false)}
            initialData={rows[selectedRowIndex]}
            onSave={handleEditSave}
            excludeFields={['action', 'status']}
            readOnlyFields={['createdBy']}
            title="Edit Continents"
          />
        )}

    </>
  );
};


export default Continents;


